import type { FaireProductEntity } from "../../entity_types/product";

export const p_1m77f60fmt: FaireProductEntity = {
  token: "p_1m77f60fmt",
  type: "product",
  name: "Shampoo 16 oz (pump not included) Reusable packaging",
  brandToken: "b_8777nmps",
  brandName: "Plaine Products",
  imageUrl:
    "https://cdn.faire.com/fastly/abfd54def042eec287b7dede452c5a2d6687eb3e98c71a5555253114b40ea53c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93c9b763bc376ab14ae20c155792276cc7bf8c6d8a2a87d3e44de94ec5b40259.jpeg",
    "https://cdn.faire.com/fastly/278c0fcd63b16ad04e54daaaf139e35326e4589922e50398a82c5f89900c4d5e.jpeg",
    "https://cdn.faire.com/fastly/3753cdaf6994f21bd6de3d605fea52ee1325956715405084cf6f53ccb235b338.jpeg",
    "https://cdn.faire.com/fastly/daa800a45a7bf5ff275541e1e59494f5ac01158aa60a16842ed253c835e502d9.jpeg",
    "https://cdn.faire.com/fastly/b08ad176b0e994a0b06f361624cd25c6abeafa85a0866b5f74476626816955e9.jpeg",
    "https://cdn.faire.com/fastly/3d8a1f55b01e3051ee871562388789432a0da1bcc8251e9e96756872c6c1ac29.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "Our shampoo’s vegan ingredients will gently cleanse your hair with luxurious lather while adding sheen and softness from ends to roots. With aloe as our main ingredient, as opposed to water in most shampoos, it restores essential nutrients to enhance your hair’s texture.\n\nOur shampoo is suitable for all hair types. For a deeper clean we recommend massaging the product into your scalp and leaving it in for a range 1 – 5 minutes depending on the desired effect. Follow up with our nourishing conditioner.\n\nSafe for the whole family, it’s a choice that’s good for you and the planet.  \n\nAluminum bottles can be returned for free to be washed and reused.\n\nOur Products are:\nFree of sulfates, parabens, phthalates, silicone and palm oil\nVegan and have non-GMO ingredients\nDesigned to biodegrade\nBaby safe and hypoallergenic \nCruelty-Free, Leaping Bunny certified \nFree of single-use plastic\n\nSize: 16 oz.\nScent: Unscented, Rosemary Mint Vanilla or Citrus Lavender\nCompatible with large pump.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:47:36.659Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
